export default __webpack_public_path__ + "static/media/edit.01ff3fed.svg";